import DeskVideoSlider from "../../../../assets/videos/CareerPlus-KV-Web-Slider.mp4";
import DeskVideoPoster from "../../../../assets/images/CareerPlus-KV-Web-Slider.png";

import MobilVideoSlider from "../../../../assets/videos/CareerPlus-KV-Mobil-Slider-v1.mp4";
import { Link } from "react-router-dom";

const MainVideoSection = () => {
  return (
    <section className="d-flex">
      <Link to="/application" style={{ width: "100%" }}>
        <video playsInline autoPlay muted width="100%" loop={true}>
          <source
            src={window.innerWidth < 768 ? MobilVideoSlider : DeskVideoSlider}
            type="video/mp4"
          />
        </video>
      </Link>
    </section>
  );
};
export default MainVideoSection;
